import { styled } from '@linaria/react';

export const ReportComponentWrapper = styled.div`
	position: absolute;
	right: 0;
	bottom: 10px;
	display: flex;
	height: 24.5px;
	align-items: center;
	align-self: flex-end;
	justify-content: center;
	padding: 10px;
	cursor: pointer;
	visibility: hidden;
`;

export const Message = styled.div<{ isMy: boolean }>`
	position: relative;
	display: flex;
	width: ${({ isMy }) => (isMy ? '' : 'fit-content')};
	max-width: 100%;
	flex-flow: row nowrap;
	justify-content: ${({ isMy }) => (isMy ? 'flex-end' : 'flex-start')};
	padding-right: var(--chat-horizontal-padding);
	padding-left: ${({ isMy }) =>
		'calc(var(--chat-horizontal-padding) + ' + (isMy ? 30 : 0) + 'px)'};
	color: ${({ isMy }) => (isMy ? 'var(--color-white-m)' : 'inherit')};
	padding-block: 10px;
	white-space: pre-line;
	word-break: break-word;
	@keyframes fadeinout {
		0% {
			opacity: 0;
			transform: translateY(10px);
		}
		50% {
			opacity: 1;
			transform: none;
		}
		100% {
			opacity: 0;
			transform: translateY(-10px);
		}
	}
	&::before {
		position: absolute;
		top: 11px;
		left: var(--chat-horizontal-padding);
		display: ${({ isMy }) => (isMy ? 'inline' : 'none')};
		animation: fadeinout 2s linear forwards;
		color: var(--color-white-solid);
		content: attr(data-exp);
		font-size: var(--font-size-l);
		text-shadow: 0 0 10px var(--color-white-solid),
			0 0 20px var(--color-white-solid);
	}
	&:hover,
	&:focus {
		${ReportComponentWrapper} {
			visibility: visible;
		}
	}
`;

export const ReportTextWrapper = styled.span`
	margin-left: 12px;
	color: var(--color-error);
	font-size: var(--font-size-m);
	font-weight: var(--font-weight-medium);
`;

export const ReportButtonWrapper = styled.div`
	display: flex;
	width: 144px;
	height: 35px;
	align-items: center;
	justify-content: flex-start;
	padding: 10px;
	border-radius: var(--radius-xs);
	background-color: #1e2023;
	cursor: pointer;
`;

export const ImageBaseWrapper = styled.div`
	position: relative;
	width: 160px;
	height: 160px;
	user-select: none;
`;

export const MSGIMGWrapper = styled(ImageBaseWrapper)`
	pointer-events: none;
	user-select: none;
	img {
		overflow: hidden;
		width: inherit;
		height: inherit;
		border-radius: var(--radius-l);
		object-fit: cover;
		pointer-events: all;
		transition: opacity 0.2s;
	}
	& > div {
		position: absolute;
		top: 0;
		left: 0;
	}
`;

export const TextMessageWrapper = styled.div<{ isOwn?: boolean }>`
	padding: 1rem 1.2rem;
	border-radius: var(--radius-xs);
	backdrop-filter: blur(10px);
	background-color: ${({ isOwn }) =>
		isOwn ? 'var(--color-white-xxs)' : 'var(--color-white-xs)'};
	color: ${({ isOwn }) =>
		isOwn ? 'var(--color-grey-68-solid)' : 'var(--color-grey-95-solid)'};
`;

export const MediaMessageContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
